import React from 'react';
import FieldRating from "../../rating";
import {isBulkSelection} from "../../../../../gd/right-click-menu";

type Props = {
    className?  : string
    value       : number
    disabled    : boolean
    onChange?   : callback
    showEmpty?  : boolean
    field       : FieldRating
}

type State = {
    value           : any
    displayValue    : any
}

export default class FieldRating_EditableStateful extends React.Component<Props,State> {

    // static propTypes = {
    //     field: PropTypes.object,
    //     value: PropTypes.number,
    //
    //     showEmpty: PropTypes.bool,
    //     disabled: PropTypes.bool,
    //
    //     onChange: PropTypes.func,
    // }

    static defaultProps = {
        value: 0,
        showEmpty: true
    }

    state = {
        value: this.props.value,
        displayValue: null
    }

    static getDerivedStateFromProps(props:any, state:any) {

        if (props.value !== state.value) {
            return {
                value   : props.value,
                displayValue        : state.displayValue
            }
        }

        return null // no changes
    }

    onStarMouseEnter = (e:React.SyntheticEvent, value:any) => {

        if (this.props.disabled) return

        this.setState({
            displayValue: value
        });
    }

    onStarMouseLeave = (e:React.SyntheticEvent) => {
        if (this.props.disabled) return

        this.setState({
            displayValue: null,
        });
    }

    onClick = (e:React.MouseEvent, value:any) => {
        if (isBulkSelection(e)) return
        if (this.props.disabled) return

        const newValue = _.isNil(value) ? 0 : value;
        this.setState({value: newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue);
        });
    }

    onReset = (e:React.MouseEvent) => {
        this.onClick(e, null);
    }

    render() {
        const value = this.state.displayValue ? this.state.displayValue : this.state.value;
        const stars = new Array(this.props.field.scale).fill(true).fill(false, value);

        const classes = Classes("ui5-selector-rating fs-13", {
            'is-empty': !this.state.value,
            'show-empty': this.props.showEmpty
        })

        return (
            <div className={Classes("flex-row-left-center no-border min-h-36", this.props.className)}>
                <div className={classes}>
                    {_.map(stars, (value, key)=>{
                        const classes = Classes("icon", {
                            'filled i5-star': value,
                            'empty i5-star-empty': !value,
                        });
                        const starValue = key + 1;
                        return <div key={key}
                                    className={classes}
                                    onMouseEnter={e=>{this.onStarMouseEnter(e,starValue)}}
                                    onMouseLeave={e=>{this.onStarMouseLeave(e)}}
                                    onClick={e=>this.onClick(e, starValue)}/>
                    })}

                </div>
            </div>
        )
    }
}
